module.exports = "/_next/static/images/be2975bdd48d6c2f1ac359b83e1f9558-women-md.png.webp";